// Images data
export const GoohubLogo:string = require('./goohub-logo.png');
export const GoohubIcon:string = require('./goohub-icon.png');
export const SearchIcon:string = require('./icons/search.svg');
export const MicIcon:string = require('./icons/google-mic.svg');
export const CancelIcon:string = require('./icons/cancel.svg');
export const RepositoryIcon:string = require('./icons/repository.svg');
export const StatisticsIcon:string = require('./icons/statistics.svg');
export const PeopleIcon:string = require('./icons/people.svg');
export const LeftChevron:string = require('./icons/left-chevron.svg');
export const RightChevron:string = require('./icons/right-chevron.svg');




